// extracted by mini-css-extract-plugin
export var required = "_gi-0";